<template>
    <div class="preloader-block">
        <preloader class="preloader-block" />
    </div>
</template>

<script>
    import Preloader from "./preloader.vue";

    export default {
        components: {Preloader},
        name: 'PreloaderBlock'
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/preloader-block.vue